import { IPublicClientApplication } from "@azure/msal-browser";

import { axiosGetRequest } from "../../api/ApiClient";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";

const route = "/docente/v1/feriados";

function getHolidays(
    data_inicial: string,
    data_final: string,
    instance: IPublicClientApplication
) {
    const params = StringUtils.getQueryParams({
        data_inicial,
        data_final,
    });

    return axiosGetRequest(
        `${route}${params}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

export default {
    getHolidays,
};
